import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { ToastrService } from 'ngx-toastr';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { select, Store } from '@ngrx/store';
import { getStepDetails, getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ReferenceLibraryService } from '../../../../services/referenceLibrary.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import { updatei140StepStatus, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { first } from 'rxjs/internal/operators/first';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { SubTaskDetails } from 'dist/app-models/public-api';
import { PrimaryData } from 'app-models';
// import { SubTaskDetails } from 'app-models';
import { AppServicesLibraryService } from 'app-services-library';

@Component({
  selector: 'app-processing-information',
  templateUrl: './processing-information.component.html',
  styleUrls: ['./processing-information.component.scss']
})
export class ProcessingInformationComponent implements OnInit, OnDestroy {

  inputData: PrimaryData;
  procesingInformationForm: FormGroup;
  showOtherFormsFlag: boolean;
  countryList: [];
  stateList: [];
  listOfForms: ReferenceLibrary[];
  selectedCountryCode: any;
  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;

  observableSubscription$ = new Subject();
  formChangesSubscription: any;
  guardSubscription: any;
  subTaskDetails: any;
  fieldExtraordinaryAbility: any;
  response: any;
  docCheckbox: boolean;
  checkBoxValidation = true;
  showNext: boolean = false;
  showPrev: boolean = false;

  constructor(
    private procesingInformationBuilder: FormBuilder,
    private cacheCountryService: CacheCountryService,
    private referenceLibraryService: ReferenceLibraryService,
    private store: Store<any>,
    private pbService: PetitionBuilderService,
    private toastr: ToastrService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private guard: DirtyFormGuard,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.disabledControls = false;
    this.countryList = [];
    this.stateList = [];
    this.showOtherFormsFlag = false;
    this.docCheckbox = false;
    this.inputData = this.dynamicDialogConfig.data;
    this.showNext = this.inputData?.showNext; 
    this.showPrev = this.inputData?.showPrev;
  }

  ngOnInit() {
    // Selector for step status update
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });
    // Select the SubtaskDetails
    this.store.pipe(select(getSubTaskDetails)).pipe(takeUntil(this.observableSubscription$))
      .subscribe(task => {
        if (task.id) {
          this.subTaskDetails = task.taskTypeDetails;
        }
      })

    this.procesingInformationForm = this.procesingInformationBuilder.group({
      taskId: [],
      superTaskId: [],
      decisionId: [],
      gcI140CaseId: [],
      extraordinaryAbility: [],
      nonImmVisaNum: [''],
      willApplForVisaAbrd: [],
      visaApplCountryCode: [''],
      visaApplCity: [''],
      willApplForAos: [''],
      permResAbrdCountryCode: [''],
      anyOthPetFilWithI140: [false],
      otherPetTypes: this.procesingInformationBuilder.array([]),
      otherForms: [],
      isPersInRemvlProc: [false],
      hasImmVisaFil: [false],
      isFilWithoutLbrCert: [false],
      isReqForDupLbrCert: [false],
      documentaryEvidence: [],
      threeMajorDocumentaryEvidence: this.procesingInformationBuilder.group({
        evidenceReceipt: [],
        evidenceAchievement: [],
        evidencePublished: [],
        evidenceJudge: [],
        evidenceSignificance: [],
        evidenceAuthorship: [],
        evidenceArtistic: [],
        evidencePerformance: [],
        evidenceSalary: [],
        evidenceArts: [],
      }),
      personDocumentaryEvidence: this.procesingInformationBuilder.group({
        evidencePrice: [],
        evidenceMembership: [],
        evidenceProfessional: [],
        evidencePanel: [],
        evidenceResearch: [],
        evidenceArticals: [],
      }),
      toAmendPrevPetition: [],
      prevPetitionReceiptNumber: [],
      scheduleAgroupIOrII:[],
      occupation: [],
      annualIncome: []
    });
    this.getWageUnitType();
    this.getCountryList();
    this.getFormsList();
    this.updateFormControls();
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.getProcessingInformation();
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      this.toggleControlsStatus();
    });
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.procesingInformationForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
      if (this.procesingInformationForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });

    if (this.subTaskDetails.immClassification === 'EB-1a' || this.subTaskDetails.immClassificationCode === 'EB1ALIENSELF') {
      this.procesingInformationForm.get('extraordinaryAbility').setValidators(Validators.required);

      this.procesingInformationForm.controls.threeMajorDocumentaryEvidence.valueChanges.subscribe((res) => {
        if ((JSON.stringify(res).includes("true"))) {
          this.docCheckbox = true;
          this.checkBoxValidation = Object.values(res).filter(res => { return res == true }).length > 2 ? false : true;

        } else {
          this.docCheckbox = false;
          this.checkBoxValidation = true;
        }
      });

      this.procesingInformationForm.controls.documentaryEvidence.valueChanges.subscribe((res) => {
        this.checkBoxValidation = res ? false : true;
    });
    }


    if (this.subTaskDetails.immClassification === 'EB-1b') {
      this.procesingInformationForm.controls.personDocumentaryEvidence.valueChanges.subscribe((res) => {
        if ((JSON.stringify(res).includes("true"))) {
          this.checkBoxValidation = Object.values(res).filter(res => { return res == true }).length > 1 ? false : true;
        } else {
          this.checkBoxValidation = true;
        }
      });
    }

    if((this.subTaskDetails.immClassification !== 'EB-1a' && this.subTaskDetails.immClassificationCode !== 'EB1ALIENSELF') && this.subTaskDetails.immClassification !== 'EB-1b'){
      this.checkBoxValidation = false;
    }
  }
  

  getWageUnitType() {
    this.referenceLibraryService.getReferenceDataWithoutAuthentication('EB1AFLDEXTRABL').pipe(takeUntil(this.observableSubscription$)).subscribe((response: ReferenceLibrary[]) => {
      this.fieldExtraordinaryAbility = response;
    });
  }

  getFormsList() {
    this.referenceLibraryService.getReferenceData('OTHPETTYP').pipe(takeUntil(this.observableSubscription$)).subscribe((response: ReferenceLibrary[]) => {
      this.listOfForms = response;
      const group = this.procesingInformationBuilder.group({});
      this.listOfForms.forEach((form) => {
        group.addControl(form.id.toString(), this.procesingInformationBuilder.control(false, []));
      });
      (this.procesingInformationForm.get('otherPetTypes') as FormArray).push(group);
      this.procesingInformationForm.updateValueAndValidity();
    });
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  updateFormControls() {
    this.procesingInformationForm.get('willApplForVisaAbrd').valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe((value) => {
      if (value) {
        this.procesingInformationForm.get('visaApplCountryCode').setValidators(Validators.required);
        this.procesingInformationForm.get('visaApplCity').setValidators(Validators.required);
      } else {
        this.procesingInformationForm.get('visaApplCountryCode').clearValidators();
        this.procesingInformationForm.get('visaApplCity').clearValidators();
      }
      this.procesingInformationForm.get('visaApplCountryCode').reset();
      this.procesingInformationForm.get('visaApplCity').reset();
      this.procesingInformationForm.updateValueAndValidity();
    });

    this.procesingInformationForm.get('willApplForAos').valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe((value) => {
      if (value) {
        this.procesingInformationForm.get('permResAbrdCountryCode').setValidators(Validators.required);
      } else {
        this.procesingInformationForm.get('permResAbrdCountryCode').clearValidators();
      }
      this.procesingInformationForm.get('permResAbrdCountryCode').reset();
      this.procesingInformationForm.get('permResAbrdCountryCode').updateValueAndValidity();
    });
  }

  //To fetch  list of countries
  getCountryList() {
    this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
      if (data.listCountries.length > 0) {
        this.countryList = data.listCountries;
        this.selectedCountryCode = this.countryList['countryCode'];
      }
    });
  }

  postProcessingInformation() {
    this.pbService.postProcessingInformation(this.procesingInformationForm.value, this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      this.toastr.success(response.message, 'Success');
      if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
        this.updateStepStatus('INPROGRESS');
      }
      this.getProcessingInformation();
    });
  }

  updateStepStatus(status) {
    console.log("status", status);
    this.store.dispatch(updatei140StepStatus({ payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status), subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode }));
  }

  handleDataChange(group: string, event: any,) {
    if (!event.checked) {
      this.showOtherFormsFlag = false;
      this.procesingInformationForm.controls[group].clearValidators();
      this.procesingInformationForm.updateValueAndValidity();
      this.procesingInformationForm.controls[group].reset();
    }
  }

  handleDataChangeOtherForms(event: any, code: string) {
    if (code === 'OTHER') {
      this.showOtherFormsFlag = event.checked;
      this.procesingInformationForm.controls['otherForms'].clearValidators();
      this.procesingInformationForm.updateValueAndValidity();
      this.procesingInformationForm.controls['otherForms'].reset();
    }
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  getProcessingInformation() {
    this.pbService.getProcessingInformation(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
      response['isPersInRemvlProc'] = response['isPersInRemvlProc'] === null ? false : response['isPersInRemvlProc'];
      response['hasImmVisaFil'] = response['hasImmVisaFil'] === null ? false : response['hasImmVisaFil'];
      response['isFilWithoutLbrCert'] = response['isFilWithoutLbrCert'] === null ? false : response['isFilWithoutLbrCert'];
      response['isReqForDupLbrCert'] = response['isReqForDupLbrCert'] === null ? false : response['isReqForDupLbrCert'];
      response['anyOthPetFilWithI140'] = response['anyOthPetFilWithI140'] === null ? false : response['anyOthPetFilWithI140'];
      this.procesingInformationForm.reset(response);
      if (this.subTaskDetails.immClassification === 'EB-1a' || this.subTaskDetails.immClassificationCode === 'EB1ALIENSELF') {
        const majorDocmentoryvalues = this.procesingInformationForm.value?.threeMajorDocumentaryEvidence;
        const documentaryEvidenceValue = this.procesingInformationForm.value?.documentaryEvidence;
        this.checkBoxValidation = Object.values(majorDocmentoryvalues).filter(res => { return res == true }).length > 2 ? false : true;
        if(documentaryEvidenceValue){
          this.checkBoxValidation = false;
        }
      }
      if (response && response['otherForms']) {
        this.showOtherFormsFlag = response['otherForms'].length > 0 ? true : false;
      }
    });
  }

  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  handleCancel() {
    this.getProcessingInformation();
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }
}
